import App from 'app/app.js';
import 'app/store/VisualMerchandiseStore.js';
import sheets4wallet from 'html/customize/sheets-4wallet.html';
import sheets2x3wallet from 'html/customize/sheets-2x3-1x2wallet.html';
import sheets8wallet from 'html/customize/sheets-8wallet.html';
import sheets3x5_2x3wallet from 'html/customize/sheets-3x5-2x3-wallet.html';
import sheets3x5wallet from 'html/customize/sheets-3x5wallet.html';
import sheets5x7_1x2wallet from 'html/customize/sheets-5x7-1x2-wallet.html';
import sheets5x7wallet from 'html/customize/sheets-5x7wallet.html';
import sheets4confmagnet from 'html/customize/sheets-4conf-magnet.html';
import sheets6confmagnet from 'html/customize/sheets-6conf-magnet.html';
import sheets8exchange from 'html/customize/sheets-8exchange.html';
import sheets18exchange from 'html/customize/sheets-18exchange.html';
import sheets3x5_1x2 from 'html/customize/sheets-3x5-1x2.html';
import sheets3x5_2 from 'html/customize/sheets-3x5-2.html';
import sheets3x5 from 'html/customize/sheets-3x5.html';
import sheets5x7 from 'html/customize/sheets-5x7.html';
import sheets8x10 from 'html/customize/sheets-8x10.html';
import sheets10x13 from 'html/customize/sheets-10x13.html';
import sheetsCd from 'html/customize/sheets-cd.html';
import sheetsDigital from 'html/customize/sheets-digital.html';
import sheetsMagnet from 'html/customize/sheets-magnet.html';

function LtCustomSheetDirective($compile, $templateCache, VisualMerchandiseStore, $location) {
  const templateMap = [
    {
      group: 'DG_WALLET',
      templates: {
        4: sheets4wallet,
        6: sheets2x3wallet,
        8: sheets8wallet
      }
    },
    {
      group: 'DG_3X5_WALLET',
      templates: {
        3: sheets3x5_2x3wallet,
        other: sheets3x5wallet
      }
    },
    {
      group: 'DG_5X7_WALLET',
      templates: {
        10: sheets5x7_1x2wallet,
        other: sheets5x7wallet
      }
    },
    {
      group: 'DG_CONF_MAGNET',
      templates: {
        4: sheets4confmagnet,
        6: sheets6confmagnet
      }
    },
    {
      group: 'DG_EXCHANGE',
      templates: {
        8: sheets8exchange,
        18: sheets18exchange
      }
    },
    {
      group: 'DG_3X5',
      templates: {
        11: sheets3x5_1x2,
        2: sheets3x5_2,
        other: sheets3x5
      }
    },
    {
      group: 'DG_5X7',
      templates: {
        other: sheets5x7
      }
    },
    {
      group: 'DG_8X10',
      templates: {
        other: sheets8x10
      }
    },
    {
      group: 'DG_10X13',
      templates: {
        other: sheets10x13
      }
    },
    {
      group: 'DG_IMAGE_CD',
      templates: {
        other: sheetsCd
      }
    },
    {
      group: 'DG_HIGH_DIGITAL',
      templates: {
        other: sheetsDigital
      }
    },
    {
      group: 'DG_LOW_DIGITAL',
      templates: {
        other: sheetsDigital
      }
    },
    {
      group: 'DG_MAGNET',
      templates: {
        other: sheetsMagnet
      }
    },
    {
      group: 'DG_OTHER',
      templates: {
        other: sheets8x10
      }
    }
  ];

  var findTemplate = function (group, count) {
    var entry = R.find(R.propEq('group', group), templateMap),
      template = !!entry ? R.prop(count, entry.templates) : undefined;

    return !!template ? template : !!entry ? R.prop('other', entry.templates) : undefined;
  };

  return {
    restrict: 'E',
    replace: true,
    scope: {
      orderLineDetail: '=',
      packageAdded: '=',
      showPrice: '='
    },
    compile: function (tElement, tAttrs) {
      return function (scope, element, attrs) {
        //two pages have look information below the image, two do not.
        var currentRoute = $location.path();
        if (
          currentRoute.indexOf('package-detail') > -1 ||
          currentRoute.indexOf('bundle-detail') > -1 ||
          currentRoute.indexOf('addon-detail') > -1
        ) {
          scope.showNewLayout = true;
        }

        var htmlTemplate,
          initImageSize = function (imgList) {
            var i, img;

            for (i = 0; i < imgList.length; i++) {
              img = angular.element(imgList[i]);
              img.attr(
                'style',
                'width:' + (img.parent().height() + 1) + 'px;' + 'height:' + (img.parent().width() + 1) + 'px;'
              );
            }
          },
          loadTemplate = function () {
            if (scope.orderLineDetail && scope.orderLineDetail.item) {
              htmlTemplate = findTemplate(
                scope.orderLineDetail.item.displayGroup,
                scope.orderLineDetail.item.imageCount
              );
              element.html(!!htmlTemplate ? $compile(htmlTemplate)(scope) : '');
              initImageSize(angular.element(element).find('img.rotate270'));
            }
          },
          unbindLook = scope.$watch(
            function () {
              return scope.orderLineDetail.look;
            },
            function () {
              loadTemplate();
            },
            true
          ),
          unbindSheet = scope.$watch(
            function () {
              return scope.orderLineDetail.item;
            },
            function () {
              loadTemplate();
            }
          );

        scope.$on('$destroy', function () {
          unbindLook();
          unbindSheet();
        });

        loadTemplate();
      };
    }
  };
}

App.directive('ltCustomSheet', [
  '$compile',
  '$templateCache',
  'VisualMerchandiseStore',
  '$location',
  LtCustomSheetDirective
]);
